__turbopack_context__.v({
  "appearAnimation": "VIdeoForCarousal-module__509KbG__appearAnimation",
  "replayBtn": "VIdeoForCarousal-module__509KbG__replayBtn",
  "root": "VIdeoForCarousal-module__509KbG__root",
  "videoContainer": "VIdeoForCarousal-module__509KbG__videoContainer",
});
